export default __webpack_public_path__ + "static/media/main-category-coworking.dfeae313.jpg";